const app = {
  state: {
    returnTitle: '', // 返回类型页面的title
    returnNum: '', // 返回类型页面的数字
    returnUrl: '', // 返回类型页面的返回地址
    cardType: 'normal', // 白块类型 normal large
    delModal: false, // 是否开启删除弹窗（账号权限）
    accountName: '' // 删除账号的名称（账号权限）
  },
  mutations: {
    SET_RETURN_TITLE(state, title) {
      state.returnTitle = title
    },
    SET_RETURN_NUM(state, num) {
      state.returnNum = num
    },
    SET_RETURN_URL(state, url) {
      state.returnUrl = url
    },
    SET_RETURN_FULLURL(state, fullUrl) {
      state.returnFullUrl = fullUrl
    },
    SET_RETURN_TYPE(state, type) {
      state.cardType = type
    },
    SET_RETURN_Params(state, params) {
      state.params = params
    },
    SET_DEL_MODAL(state, type) {
      state.delModal = type
    },
    SET_ACCOUNT_NAME(state, name) {
      state.accountName = name
    }
  },
  actions: {
    setPage({ commit }, obj) {
      commit('SET_RETURN_TITLE', obj.title || '返回')
      commit('SET_RETURN_NUM', obj.num || '')
      commit('SET_RETURN_URL', obj.url || '')
      commit('SET_RETURN_TYPE', obj.type || 'normal')
      commit('SET_RETURN_Params', obj.params || '')
    },
    deleteAccount({ commit }, obj) {
      commit('SET_DEL_MODAL', obj.type)
      commit('SET_ACCOUNT_NAME', obj.name)
    }
  }
}

export default app
